import React, { useState, useEffect } from "react";

import { Table, OverlayTrigger, Popover } from "react-bootstrap";

import authenticatedFetch from "../../../utils/fetch"
import RevenueTeamLabel from "../../../components/RevenueTeamLabel";
import LastActivityDisplay from "../../../utils/LastActivityDisplay";
import { TaskCard } from "../../../utils/TaskCardParts";

const waitingTableStyles = `
.waiting-table { margin-bottom: 0; }
.waiting-table thead th { font-size: 0.7rem; font-weight: 500; color: #6B7274; border-bottom: 1px solid #DCE5E3; padding: 6px 16px; background: transparent; }
.waiting-table tbody td { padding: 11px 16px; border-top: 1px solid #EEF2F1; border-bottom: 0; background: transparent; vertical-align: middle; }
.waiting-table tbody tr:hover td { background: #EEF5F3; }
.waiting-table .days-col { text-align: right; font-variant-numeric: tabular-nums; }
`;


const RegionPill = ({ label, count, selected, onClick }) => (
  <button
    type="button"
    onClick={onClick}
    className="me-2 mb-1"
    style={{
      border: 0, borderRadius: "999px", padding: "2px 10px", fontSize: "0.75rem", fontWeight: 500, lineHeight: "18px",
      background: selected ? "#3E8A80" : "#D9E5E2", color: selected ? "#fff" : "#2F4F4A",
    }}
  >
    {label} <span style={{fontWeight: 400, opacity: 0.8}}>{count}</span>
  </button>
);

const BlockedList = () => {
  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [data, setData] = useState([]);
  const [selectedRegion, setSelectedRegion] = useState(null);

  useEffect(() => {
    authenticatedFetch({
      path: "task/blockedinternally/v2",
      successHandler: function(result) {
        setIsLoaded(true);
        setData(result);
      },
      errorHandler: function(error) {
        setIsLoaded(true);
        setError(error);
      }
    });
  }, [])

  function handleTaskClicked(e, taskId)
  {
    e.preventDefault();
    window.location = "/tasks?task=" + taskId;
  }

  function getProviderLastNameFirstInitial(task)
  {
    if (task.providerLastNameFirstName == null || task.providerLastNameFirstName.length === 0)
    {
      if (task.practiceName == null || task.practiceName.length === 0)
      {
        return "";
      }

      return task.practiceName.length > 25 ? task.practiceName.substring(0, 25).trim() + "..." : task.practiceName;
    }

    var parts = task.providerLastNameFirstName.split(", ");
    var name = (parts.length < 2 || parts[1].length === 0) ? task.providerLastNameFirstName : parts[0] + ", " + parts[1].charAt(0) + ".";

    return task.providerIsDeleted ? <>{name}</> : <a href="#" onClick={(e) => handleProviderClicked(e, task.providerId)} style={{color: "#495057"}}>{name}</a>;
  }

  function getOwner(task)
  {
    var nonH3Assignees = (task.assignees || []).filter(function(assignee) { return !assignee.isH3Admin; });
    if (nonH3Assignees.length > 0)
    {
      return nonH3Assignees.map(function(assignee) { return assignee.firstName + " " + assignee.lastName.charAt(0) + "."; }).join(", ");
    }

    if (task.status === "BLOCKED_INTERNALLY_PROVIDER")
    {
      return "Provider";
    }

    return "-";
  }

  function getRegion(task)
  {
    return (task.practiceGrouping && task.practiceGrouping.trim()) || "Unassigned";
  }

  const handleProviderClicked = (e, providerId) => {
    e.stopPropagation();
    e.preventDefault();
    window.location = "/provider/" + providerId;
  }

  var showRegion = Array.isArray(data) && data.some((task) => task.practiceGrouping != null && task.practiceGrouping.trim() !== "");

  var regionCounts = [];
  if (showRegion)
  {
    var regionCountsByName = {};
    data.forEach((task) => {
      var region = getRegion(task);
      if (!regionCountsByName[region])
      {
        regionCountsByName[region] = 0;
        regionCounts.push(region);
      }
      regionCountsByName[region]++;
    });
    regionCounts = regionCounts
      .map((region) => ({name: region, count: regionCountsByName[region]}))
      .sort((a, b) => {
        if (a.name === "Unassigned") return 1;
        if (b.name === "Unassigned") return -1;
        return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
      });
  }

  var visibleData = (showRegion && selectedRegion) ? data.filter((task) => getRegion(task) === selectedRegion) : data;

  var taskList;
  if (error || !data)
  {
    taskList = <tr><td colSpan={showRegion ? "5" : "4"}>Something went wrong... please reload the page...</td></tr>
  }
  else if (!isLoaded)
  {
    taskList = <tr><td colSpan={showRegion ? "5" : "4"}>Loading...</td></tr>
  }
  else
  {
    taskList = visibleData.map((task, i) => {
      var isDaysRed = task.days > 2;
      return (
        <OverlayTrigger
          key={task.id}
          trigger={["hover", "focus"]}
          placement="bottom"
          overlay={<Popover><Popover.Body><LastActivityDisplay task={task} /></Popover.Body></Popover>}
        >
          <tr style={{cursor: "pointer"}} onClick={(e) => {handleTaskClicked(e, task.id)}}>
            {showRegion && <td style={{whiteSpace: "nowrap"}}>{(task.practiceGrouping && task.practiceGrouping.trim()) || "-"}</td>}
            <td style={{whiteSpace: "nowrap"}}><strong>{getProviderLastNameFirstInitial(task)}</strong></td>
            <td>{task.other}</td>
            <td>{getOwner(task)}</td>
            <td className="days-col" style={isDaysRed ? {color: "#C2453D", fontWeight: 500} : undefined}>{task.days}</td>
          </tr>
        </OverlayTrigger>
      )
    }, this);
  }

  return (
    <TaskCard className="flex-fill w-100" title={<>Waiting on <RevenueTeamLabel /></>} count={visibleData.length}>
    <style>{waitingTableStyles}</style>
    {isLoaded && !error &&
      <div className="d-flex flex-wrap align-items-center px-3 pb-2">
        {showRegion &&
          <>
          <span className="me-2 mb-1" style={{fontSize: "0.7rem", fontWeight: 500, letterSpacing: "0.5px", color: "#6B7274"}}>REGION</span>
          <RegionPill label="All" count={data.length} selected={!selectedRegion} onClick={() => setSelectedRegion(null)} />
          {regionCounts.map((region) => (
            <RegionPill key={region.name} label={region.name} count={region.count} selected={selectedRegion === region.name} onClick={() => setSelectedRegion(region.name)} />
          ))}
          </>
        }
      </div>
    }
    <Table hover style={{fontSize: "0.75rem"}} className="table-sm waiting-table">
      <thead>
        <tr>
          {showRegion && <th>Region</th>}
          <th>Provider</th>
          <th>What it's Waiting on</th>
          <th>Owner</th>
          <th className="days-col">Days</th>
        </tr>
      </thead>
      <tbody>
        {taskList}
      </tbody>
    </Table>
    </TaskCard>
  )
}


const Blocked = () => <BlockedList />;

export default Blocked;
